/* eslint-disable */
YP.NewsletterTemplate = function() {
    var $initFormUrl = $('.js-campaign-html').data('href');
    var $hasHtmlCampaign = $('.has-html-campaign');

    return {
        init: function() {
            klass = this;
            $.ajax({
                url: $initFormUrl,
                type: "GET",
                dataType: 'json',
                success: function(data) {
                    $.each( data.form_elements, function( key, html ) {
                        $('.js-campaign-target-form-' + key + '-container').append(html);
                        // Check if element was present the first time template was saved
                        if( 
                            $('.js-campaign-target-form-'+key+'-content-container').length > 0 &&
                            $('.js-campaign-target-form-'+key+'-content-container').html().length == 0
                        ) 
                        {
                            $('.js-campaign-target-form-'+key+'-content-container').html($('.js-campaign-form-form-' + key + '-content').html());
                            $('.js-campaign-target-form-'+key+'-switch').css('opacity', 0.2);
                            $('.js-campaign-form-form-'+key+' input').prop("checked", false);
                            $('.js-campaign-target-form-'+key+'-switch').addClass('js-campaign-to-remove').css('opacity', 0.2);
        
                        }
                    });
                    if(data.dynamic_elements) {
                        $.each( data.dynamic_elements, function( key, html ) {
                            if($('.js-campaign-dynamic-elem-' + key + '-container').html()) {
                                if($('.js-campaign-dynamic-elem-' + key + '-container').html().replace(/\s/g, '').length == 0) {
                                    $('.js-campaign-dynamic-elem-' + key + '-container').append(html);
                                }
                            }
                        });
                    }
                    klass.getSubForm();
                    $('.js-campaign-html').css('opacity', 1);
                }

            });
        },
        getSubForm: function() {
            klass = this;
            $("div[class^='js-campaign-content-form']").each(function (i, el) {
                typeForm = $(el).attr('class').split('-').slice(-1).pop();
                klass.initSubForm(typeForm);
            });
        },
        initSubForm: function(type) {
            klass = this;
            $('.js-campaign-init-form-'+ type).on('click', function(e){
                $('.js-campaign-form-form-'+ type).toggle();
                $(this).toggleClass('js-open');
            });
            klass.initSpectrumColor(type);
            klass.initSpectrumBackgroundColor(type);
            klass.initRedactor(type);
            klass.initSwitch(type);

        },
        initSpectrumColor: function(type) {
            klass = this;
            if($('.js-campaign-init-form-'+ type + '-color input').length) {
                defaultColor = $('.js-campaign-target-form-' + type + '-color').css('color');
                $('.js-campaign-init-form-'+ type + '-color input').attr('value', defaultColor).spectrum({
                    preferredFormat: "hex",
                    clickoutFiresChange: true,
                    showInitial: true,
                    showInput: true,
                    chooseText: "Choisir",
                    cancelText: "Annuler",
                    showPalette: true,
                    showSelectionPalette: true,
                    palette: [],
                    localStorageKey: "yurplan.spectrum_newsletter",
                    move: function(color) {
                        $('.js-campaign-target-form-' + type + '-color').css('color', color.toHexString());
                        klass.updateHtml();
                    },
                    change: function(color) {
                        $('.js-campaign-target-form-' + type + '-color').css('color', color.toHexString());
                        klass.updateHtml();
                    },
                });
            }

        },
        initSpectrumBackgroundColor: function(type) {
            klass = this;
            if($('.js-campaign-init-form-'+ type + '-background input').length) {
                defaultColor = $('.js-campaign-target-form-' + type + '-background').css('background-color');
                $('.js-campaign-init-form-'+ type + '-background input').attr('value', defaultColor).spectrum({
                    preferredFormat: "hex",
                    clickoutFiresChange: true,
                    showInitial: true,
                    showInput: true,
                    chooseText: "Choisir",
                    cancelText: "Annuler",
                    showPalette: true,
                    showSelectionPalette: true,
                    palette: [],
                    localStorageKey: "yurplan.spectrum_newsletter",
                    move: function(color) {
                        $('.js-campaign-target-form-' + type + '-background').css('background-color', color.toHexString());
                        klass.updateHtml();
                    },
                    change: function(color) {
                        $('.js-campaign-target-form-' + type + '-background').css('background-color', color.toHexString());
                        klass.updateHtml();
                    },
                });
            }
        },
        initRedactor: function(type) {
            klass = this;
            if($('.js-campaign-init-form-'+ type + '-text input[type="text"]').length) {
                var $input = $('.js-campaign-init-form-'+ type + '-text input[type="text"]');
                var $target = $('.js-campaign-target-form-'+ type + '-text');
                var $targetP = $target.find('p');

                var textValue = $targetP.length > 0 ? $targetP.first().text().trim() : $target.first().text().trim();
                $input.val(textValue);

                $input.on('input keyup', function() {
                    if($targetP.length > 0) {
                        $targetP.text($(this).val());
                    } else {
                        $target.text($(this).val());
                    }
                    klass.updateHtml();
                });
            } else if($('.js-campaign-init-form-'+ type + '-text textarea').length) {
                var buttonsToHide = $hasHtmlCampaign.length > 0 ? [''] : ['html'];
                $('.js-campaign-init-form-'+ type + '-text textarea').val($('.js-campaign-target-form-'+ type + '-text').html());
                $('.js-campaign-init-form-'+ type + '-text textarea').redactor({
                    iframe: true,
                    focus: true,
                    plugins: ['fontfamily', 'fontsize'],
                    buttonsHide: buttonsToHide,
                    changeCallback: function() {
                        $('.js-campaign-target-form-'+ type + '-text').html(this.code.get());
                        klass.updateHtml();
                    }
                });
            }
        },
        initSwitch: function(type) {
            klass = this;
            if($('.js-campaign-form-form-'+type+' input').length) {
                if($('.js-campaign-target-form-'+type+'-switch').html() == "") {
                    $('.js-campaign-target-form-'+type+'-switch').append(
                        $('.js-campaign-form-form-'+type+'-content').html()
                    );
                    $('.js-campaign-target-form-'+type+'-switch').css('opacity', 0.2);
                    $('.js-campaign-form-form-'+type+' input').prop("checked", false);
                }

                $('.js-campaign-form-form-'+type+' input.js-toggle').on('change', function(e) {
                    if( $(this).prop( "checked" ) == true ){
                        $('.js-campaign-target-form-'+type+'-switch').removeClass('js-campaign-to-remove').css('opacity', 1);
                    } else {
                        $('.js-campaign-target-form-'+type+'-switch').addClass('js-campaign-to-remove').css('opacity', 0.2);
                    }
                    klass.updateHtml();
                });
            }

        },
        updateHtml: function() {
            if ($('.js-campaign-html').length > 0) {
                copyHtml = $('.js-campaign-html').clone();
                copyHtml.find(".js-campaign-to-remove").remove();
                copyHtml.find("div[class^='js-campaign-content-form']").remove();
                $('#template_campaign_content').val(copyHtml.html().replace( new RegExp( "\>[\n\t ]+\<" , "g" ) , "><" ));
            }
        },
    }
};
window.addEventListener("load", function() {
    if ($('.js-campaign-html').length > 0) {
        YP.NewsletterTemplate().init();
    }
});
